var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "call-routing",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#37bf9f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shuffle-svgrepo-com",
    transform: "translate(11.741 13.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M16.47,5.47a.75.75,0,0,0,0,1.061l.72.72H13.377a1.75,1.75,0,0,0-1.575.987l-.21.434a.4.4,0,0,0,0,.349l.569,1.175a.2.2,0,0,0,.36,0l.632-1.3a.25.25,0,0,1,.225-.141h3.813l-.72.72A.75.75,0,0,0,17.53,10.53l2-2a.75.75,0,0,0,0-1.061l-2-2A.75.75,0,0,0,16.47,5.47Z",
    transform: "translate(-4.25 -5.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M10.034,15.329a.4.4,0,0,0,0-.349l-.569-1.175a.2.2,0,0,0-.36,0l-.631,1.3a.25.25,0,0,1-.225.141H5a.75.75,0,0,0,0,1.5H8.248a1.75,1.75,0,0,0,1.575-.987Z",
    transform: "translate(-4.25 -5.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M16.47,18.53a.75.75,0,0,1,0-1.061l.72-.72H13.377a1.75,1.75,0,0,1-1.575-.987L8.473,8.891a.25.25,0,0,0-.225-.141H5a.75.75,0,0,1,0-1.5H8.248a1.75,1.75,0,0,1,1.575.987l3.329,6.872a.25.25,0,0,0,.225.141h3.813l-.72-.72A.75.75,0,0,1,17.53,13.47l2,2a.75.75,0,0,1,0,1.061l-2,2A.75.75,0,0,1,16.47,18.53Z",
    transform: "translate(-4.25 -5.25)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallRouting);
export default __webpack_public_path__ + "static/media/call-routing.8d834fc544841fd19f9701fd043a95e7.svg";
export { ForwardRef as ReactComponent };